export default __webpack_public_path__ + "static/remeltedwax-c06ba1b07e88fc8f00efc47fe1c8e25f.png";